import { z } from "zod";

/** Minimal job shape forms persist so a selection renders its title without
 *  re-fetching — survives unmount/remount where the full Job list isn't loaded. */
export const jobSelectionSchema = z.object({
  id: z.string().min(1),
  title: z.string(),
});

export type JobSelection = z.infer<typeof jobSelectionSchema>;
